import React from 'react'
import HRMSLayout from '../../../../../layout/components/HRMSLayout'

function HolidayListPage() {
  return (
    <HRMSLayout>
      <div>HolidayListPage</div>
    </HRMSLayout>
  )
}

export default HolidayListPage